import { useEffect } from 'react';
import { usePrintsOrderStore, usePrintsUiStore } from '../stores';
import { selectHasUnsavedChanges } from '../stores/selectors';

const UPLOAD_WARNING_MESSAGE =
  'Photo uploading in progress. If you leave this page now your upload will be incomplete.';
const PENDING_SAVE_WARNING_MESSAGE = 'Changes that you made may not be saved.';

export const useBeforeUnloadWarning = () => {
  // --- STATE ---
  const currentlyLoading = usePrintsUiStore((state) => state.currentlyLoading);
  const isSaving = usePrintsUiStore((state) => state.isSaving);

  // --- SELECTORS ---
  const hasUnsavedChanges = usePrintsOrderStore(selectHasUnsavedChanges);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      let message;

      if (currentlyLoading) {
        message = UPLOAD_WARNING_MESSAGE;
      } else if (isSaving || hasUnsavedChanges) {
        message = PENDING_SAVE_WARNING_MESSAGE;
      }

      if (message) {
        event.preventDefault();
        event.returnValue = message;
        return message;
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [currentlyLoading, isSaving, hasUnsavedChanges]);
};
